import { render } from "./NotFound.vue?vue&type=template&id=21d7ff70"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__